import { languages } from '../constants'

export const convertGraphQlToObject = (gqlObj) => {
  let obj = {
    ...gqlObj,
    translations: {}
  }
  for (let _trans of gqlObj.details) {
    obj.translations[_trans.language_id] = {
      ..._trans
    }
  }
  delete obj.details
  if (gqlObj.ttHours) {
    obj.ttHours = JSON.parse(gqlObj.ttHours)
  }
  return obj
}

export const convertObjetToGraphQlVariables = (obj) => {
  let gqlObj = {
    ...obj,
    details: []
  }
  if (gqlObj.ttHours) {
    gqlObj.ttHours = JSON.stringify(gqlObj.ttHours)
  }
  Object.keys(obj.translations).forEach(function(key,index) {
    gqlObj.details.push({
      ...obj.translations[key]
    })
  })
  delete gqlObj.translations
  return gqlObj
}

/**
 * Create a translations object
 *
 * @param {object} obj
 *
 * @return {object}
 */
export const createTranslationsObject = (obj) => {
  if (obj.hasOwnProperty('language_code')) {
    delete obj.language_code
  }

  let translationsObject = {}
  for (let language of languages) {
    translationsObject[language.code] = {...obj}
    translationsObject[language.code]['language_code'] = language.code
  }

  return translationsObject
}

/**
 * Create a translations object (OLD)
 *
 * @param {object} obj
 *
 * @return {object}
 */
export const createTranslationsObjectOld = (obj) => {
  // TODO: Remove after migration shops/categories
  if (obj.hasOwnProperty('language_id')) {
    delete obj.language_id
  }

  let translationsObject = {}
  for (const index in languages) {
    const i = parseInt(index, 10) + 1
    translationsObject[i] = {...obj}
    translationsObject[i]['language_id'] = i
  }

  return translationsObject
}



// WEBPACK FOOTER //
// ./src/helpers/translation.js